import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';

import Footer from '../components/Footer/Footer.component';
import Header from '../components/Header/Header.component';

import NavigationProvider from '../context/Navigation/navigation.provider';
import { useAuthDataContext } from '../context/auth/auth.provider';
import NotificationsDataProvider from '../context/notifications/notifications.provider';
import VehiclesProvider from '../context/vehicles/vehicles.provider';
import PrivateRoute from './private.layout';
import PublicRoute from './public.layout';

const useStyles = makeStyles((theme: Theme) => ({
  publicContainer: {},
  childrenContainer: {
    position: 'relative',
    flexGrow: 1,
  },
}));

const DefaultLayout = () => {
  const { access_token, embed } = useAuthDataContext();
  const classes = useStyles();
  let location = useLocation();
  const browserHistory = createBrowserHistory();

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_UA_ID || '');
  }, []);

  return (
    <div>
      <NotificationsDataProvider>
        <NavigationProvider>
          <VehiclesProvider>
            {!embed && access_token && <Header />}
            {access_token && !location.pathname.includes('recover-password') ? (
              <>
                <PrivateRoute />
                {browserHistory.location.pathname.includes('dashboard')
                  ? !embed && <Footer dashboard />
                  : !embed && <Footer dashboard={false} />}
              </>
            ) : (
              <PublicRoute />
            )}
          </VehiclesProvider>
        </NavigationProvider>
      </NotificationsDataProvider>
    </div>
  );
};

export default DefaultLayout;
